<template>
     <el-dialog title="结算" :visible.sync="pageShow" width="44%">
          <div class="settlelists">
               <el-table :data="dataList" style="width: 100%" ref="tableRef" height="250">
                    <el-table-column label="ID" width="80">
                         <template #default="{ row }">
                              <el-radio v-model="selectedRowId" :label="row.id"
                                   @change="handleRadioChange(row)"></el-radio>
                         </template>
                    </el-table-column>
                    <el-table-column :width="170" :label="type_id == 1 ? '应收编号' : '应付编号'">
                         <template slot-scope="{row}">
                              <span v-if="type_id === 1">{{ row.receivable_no }}</span>
                              <span v-if="type_id === 2">{{ row.handle_no }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column prop="receivable" :label="type_id == 1 ? '应收金额' : '应付金额'"></el-table-column>
                    <el-table-column prop="received" :label="type_id == 1 ? '已收金额' : '已付金额'"></el-table-column>
                    <el-table-column prop="collected" :label="type_id == 1 ? '待收金额' : '待付金额'"></el-table-column>
               </el-table>
          </div>
          <el-form :model="formData" :rules="rules" ref="formRef" label-width="80px" class="demo-ruleForm">
               <el-form-item label="选择日期" prop="settlement_date">
                    <el-date-picker style="width: 100%;" v-enter-next-input type="date" placeholder="选择日期"
                         value-format="yyyy-MM-dd" v-model="formData.settlement_date">
                    </el-date-picker>
               </el-form-item>
               <el-form-item label="金额" prop="price">
                    <el-input v-enter-next-input placeholder="请输入金额" v-model="formData.price">
                    </el-input>
               </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
               <el-button @click="close">取 消</el-button>
               <el-button type="primary" @click="save">确 定</el-button>
          </span>
     </el-dialog>
</template>

<script>
import { getSettlementApi, updateSettlementApi } from '@/api/index'
export default {
     data() {
          return {
               pageShow: false,
               formData: {
                    settlement_date: '',
                    price: ''
               },
               rules: {
                    settlement_date: [
                         { required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    price: [
                         { required: true, message: '请输入金额', trigger: 'change' }
                    ],

               },
               curId: '',
               type_id: '',//1应收 2应付
               dataList: [],
               selectedRowId: ''//已选中的表格数据
          }
     },
     methods: {
          open(option) {
               console.log('option', option)
               this.pageShow = true;
               this.curId = option.id;
               this.type_id = option.type_id;
               this.getSettlement();
          },
          close() {
               this.pageShow = false;
          },
          handleRadioChange(val) {
               console.log('val', val)
               this.selectedRowId = val.id;
          },
          save() {
               if (!this.selectedRowId) {
                    this.$message.error('请选择数据！'); return;
               }
               this.$refs.formRef.validate((valid) => {
                    console.log('校验情况', valid)
                    if (valid) {
                         // alert('submit!');
                         this.toSave();
                    } else {
                         console.log('error submit!!');
                         return false;
                    }
               });
          },
          toSave() {
               let params = {
                    id: this.curId,
                    ids: this.selectedRowId,
                    ...this.formData
               }
               updateSettlementApi(params).then(res => {
                    console.log('save', res)
                    this.$message.success('操作成功！');
                    this.formData = {
                         settlement_date: '',
                         price: ''
                    }
                    this.$refs.formRef.resetFields()
                    this.selectedRowId = ''
               })
          },
          /* 获取结算情况列表 */
          getSettlement() {
               getSettlementApi({ id: this.curId }).then(res => {
                    console.log('获取结算情况列表', res)
                    this.dataList = res.data;
               })
          }
     },
}
</script>

<style lang="less" scoped>
.demo-ruleForm {
     margin-top: 30px;
}
</style>